export default {
	timeout: {
		title: "La sesión está a punto de expirar",
		message:
			"Has estado inactivo durante un tiempo. Por seguridad, tu sesión se cerrará en breve.",
		countdown: "Cerrando en {seconds}s",
		continue: "Seguir conectado",
		logout: "Cerrar sesión ahora",
	},
	expiredByInactivity: "Tu sesión se cerró por inactividad.",
};
